<template>
  <div
    class="side-content-wrap"
    @mouseenter="isMenuOver = true"
    @mouseleave="isMenuOver = false"
    @touchstart="isMenuOver = true"
  >
    <vue-perfect-scrollbar
      ref="myData"
      :settings="{ suppressScrollX: true, wheelPropagation: false }"
      :class="{ open: isSideBarOpen }"
      class="sidebar-left rtl-ps-none ps"
    >
      <ul class="navigation-left">
        <!--<div v-if="!loading" class="logo">
          <avatar :user="currentUser" :hide-nick-name="true" />
        </div>-->
        <li id="QuickAddTaskId" class="nav-item" data-item="quickAddTasks">
          <b-popover
            :target="`QuickAddTaskId`"
            placement="right"
            triggers="hover"
            delay="300"
            custom-class="blue-popover"
            content="Quick Add Task"
          >
          </b-popover>

          <QuickAddModal />

          <div class="triangle"></div>
        </li>
        <li
          id="DashboardBtnId"
          :class="{ active: selectedParentMenu == 'dashboards' }"
          class="nav-item"
          data-item="dashboards"
          @mouseenter="toggleSubMenu"
        >
          <b-popover
            :target="`DashboardBtnId`"
            placement="right"
            triggers="hover"
            delay="300"
            custom-class="blue-popover"
            content="Dashboard"
          >
          </b-popover>
          <router-link tag="a" class="nav-item-hold" to="/overview">
            <i class="nav-icon i-Bar-Chart"></i>
            <span class="nav-text">Dashboard</span>
          </router-link>

          <div class="triangle"></div>
        </li>
        <li
          id="TeamBtnId"
          class="nav-item"
          :class="{ active: selectedParentMenu == 'team' }"
          data-item="team"
          @mouseenter="toggleSubMenu"
        >
          <b-popover
            :target="`TeamBtnId`"
            placement="right"
            triggers="hover"
            delay="300"
            custom-class="blue-popover"
            content="Team"
          >
          </b-popover>
          <router-link tag="a" class="nav-item-hold" to="/team">
            <i class="nav-icon i-Conference"></i>
            <span class="nav-text">Team</span>
          </router-link>

          <div class="triangle"></div>
        </li>
        <li
          id="ClientsBtnId"
          class="nav-item"
          :class="{ active: 'client clients'.includes(selectedParentMenu) }"
          data-item="clients"
          @mouseenter="toggleSubMenu"
        >
          <b-popover
            :target="`ClientsBtnId`"
            placement="right"
            triggers="hover"
            delay="300"
            custom-class="blue-popover"
            content="Clients"
          >
          </b-popover>
          <router-link tag="a" class="nav-item-hold" to="/Clients">
            <i class="nav-icon i-Folders"></i>
            <span class="nav-text">Clients</span>
          </router-link>

          <div class="triangle"></div>
        </li>
        <li
          id="LeaveBtnId"
          class="nav-item"
          :class="{ active: selectedParentMenu == 'leave' }"
          data-item="leave"
          @mouseenter="toggleSubMenu"
        >
          <b-popover
            :target="`LeaveBtnId`"
            placement="right"
            triggers="hover"
            delay="300"
            custom-class="blue-popover"
            content="Leave"
          >
          </b-popover>
          <router-link tag="a" class="nav-item-hold" to="/leave/summary">
            <i class="nav-icon i-Approved-Window"> </i>
            <span class="nav-text">Leave</span>
          </router-link>

          <div class="triangle"></div>
        </li>
        <li
          id="ReportsBtnId"
          class="nav-item"
          :class="{ active: selectedParentMenu == 'reports' }"
          data-item="reports"
          @mouseenter="toggleSubMenu"
        >
          <b-popover
            :target="`ReportsBtnId`"
            placement="right"
            triggers="hover"
            delay="300"
            custom-class="blue-popover"
            content="Reports"
          >
          </b-popover>
          <router-link tag="a" class="nav-item-hold" to="/reports/all">
            <i class="nav-icon i-Big-Data"> </i>
            <span class="nav-text">Reports</span>
          </router-link>

          <div class="triangle"></div>
        </li>

        <li
          id="TimeLogsBtnId"
          class="nav-item"
          :class="{ active: selectedParentMenu == 'timelogs' }"
          data-item="timelogs"
          @mouseenter="toggleSubMenu"
          @click="showTimelogModal"
        >
          <b-popover
            :target="`TimeLogsBtnId`"
            placement="right"
            triggers="hover"
            delay="300"
            custom-class="blue-popover"
            content="Time Logs"
          >
          </b-popover>
          <div class="nav-item-hold">
            <i class="nav-icon i-Timer1"> </i>
          </div>

          <div class="triangle"></div>
        </li>
        <li
          id="SettingsBtnId"
          class="nav-item"
          :class="{ active: selectedParentMenu == 'settings' }"
          data-item="settings"
          @mouseenter="toggleSubMenu"
        >
          <b-popover
            :target="`SettingsBtnId`"
            placement="right"
            triggers="hover"
            delay="300"
            custom-class="blue-popover"
            content="Manage Accounts"
          >
          </b-popover>
          <router-link tag="a" class="nav-item-hold" to="#">
            <i class="nav-icon i-Gear-2"> </i>
            <span class="nav-text">Settings</span>
          </router-link>

          <div class="triangle"></div>
        </li>
      </ul>
    </vue-perfect-scrollbar>

    <vue-perfect-scrollbar
      :class="{ open: isSideBarOpen }"
      :settings="{ suppressScrollX: true, wheelPropagation: false }"
      class="sidebar-left-secondary ps rtl-ps-none"
    >
      <div ref="sidebarChild">
        <i class="sidebar-close i-Close" @click="compactSideBarToggle"></i>
        <header>
          <div class="logo"></div>
        </header>
        <div
          class="submenu-area"
          data-parent="dashboards"
          :class="{ 'd-block': selectedParentMenu == 'dashboards' }"
        >
          <header>
            <h6>Dashboard</h6>
            <p>Select a project you're on.</p>
          </header>
          <ul class="childNav" data-parent="dashboards">
            <li class="nav-item">
              <router-link tag="a" class to="/overview">
                <i class="nav-icon i-Pie-Chart-3"></i>
                <span class="item-name">Overview</span>
              </router-link>
            </li>
            <div v-if="userClients">
              <li
                v-for="client in userClients"
                :key="client.id"
                class="nav-item"
              >
                <router-link
                  v-if="clientItemCount(client)"
                  tag="a"
                  class
                  :to="`/Client/${client.id}`"
                >
                  <i class="nav-icon i-Yes"></i>
                  <span class="item-name">
                    {{ client.name }}
                    <b-badge
                      v-if="clientItemCount(client)"
                      pill
                      :variant="
                        `${
                          clientItemCount(client) < 4
                            ? 'success'
                            : clientItemCount(client) < 6
                            ? 'warning'
                            : 'danger'
                        }`
                      "
                    >
                      {{ clientItemCount(client) }}
                      {{ `Item${clientItemCount(client) > 1 ? "s" : ""}` }}
                    </b-badge>
                    <!-- </b-row> -->
                  </span>
                  <!-- </span> -->
                </router-link>
              </li>
            </div>
            <template v-else>
              <li v-for="n in 3" :key="n" class="nav-item skeleton">
                <b-row>
                  <b-col md="2">
                    <Skeleton class="mb-10" circle width="23px" height="23px" />
                  </b-col>
                  <b-col md="10">
                    <Skeleton class="mb-10 mt-10" />
                  </b-col>
                </b-row>
              </li>
            </template>
          </ul>
        </div>
        <!-- end dashboards -->
        <div
          class="submenu-area"
          data-parent="team"
          :class="{ 'd-block': selectedParentMenu == 'team' }"
        >
          <header>
            <h6>Team</h6>
            <p>View Team</p>
          </header>
          <ul class="childNav mb-0" data-parent="leave">
            <li class="nav-item">
              <router-link tag="a" class to="/Team">
                <i class="nav-icon i-People-on-Cloud"></i>
                <span class="item-name">Team</span>
              </router-link>
            </li>
          </ul>
          <ul class="childNav" data-parent="dashboards">
            <li class="nav-item">
              <router-link
                tag="a"
                class
                to=""
                @click.native="showUsers = !showUsers"
              >
                <i class="nav-icon i-Conference"></i>
                <span class="item-name pr-5">Users</span>
                <i
                  v-show="showUsers"
                  class="nav-icon i-Arrow-Up text-right pl-5"
                  style="font-size: 0.7rem"
                ></i>
                <i
                  v-show="!showUsers"
                  class="nav-icon i-Arrow-Down text-right pl-5"
                  style="font-size: 0.7rem"
                ></i>
              </router-link>
            </li>
            <div v-if="users" v-show="showUsers">
              <li v-for="user in users" :key="user.id" class="nav-item">
                <router-link
                  style="padding-left: 5px !important; padding-bottom: 5px !important"
                  tag="a"
                  :to="
                    `/Team/User/${user.firstName.toLowerCase()}-${user.lastName.toLowerCase()}`
                  "
                >
                  <div
                    class="avatar ml-0 pl-0"
                    style="text-align: left !important;"
                  >
                    <avatar
                      :user="user"
                      :hide-nick-name="true"
                      :width="30"
                      :width-in-percent="true"
                      :only-initials="true"
                      :font-size="32"
                    />
                  </div>
                  <span class="item-name">
                    {{ user.firstName }} {{ user.lastName }}
                    <!-- </b-row> -->
                  </span>
                  <!-- </span> -->
                </router-link>
              </li>
            </div>
            <template v-else>
              <li v-for="n in 3" :key="n" class="nav-item skeleton">
                <b-row>
                  <b-col md="2">
                    <Skeleton class="mb-10" circle width="23px" height="23px" />
                  </b-col>
                  <b-col md="10">
                    <Skeleton class="mb-10 mt-10" />
                  </b-col>
                </b-row>
              </li>
            </template>
          </ul>
        </div>
        <!-- end of team -->
        <div
          class="submenu-area"
          data-parent="clients"
          :class="{ 'd-block': 'clients client'.includes(selectedParentMenu) }"
        >
          <header>
            <h6>Clients</h6>
            <p>View Clients</p>
          </header>
          <ul class="childNav" data-parent="dashboards">
            <li class="nav-item">
              <router-link
                tag="a"
                class
                to=""
                @click.native="showClients = !showClients"
              >
                <i class="nav-icon i-Conference"></i>
                <span class="item-name pr-5">Clients</span>
                <i
                  v-show="showClients"
                  class="nav-icon i-Arrow-Up text-right pl-5"
                  style="font-size: 0.7rem"
                ></i>
                <i
                  v-show="!showClients"
                  class="nav-icon i-Arrow-Down text-right pl-5"
                  style="font-size: 0.7rem"
                ></i>
              </router-link>
            </li>
            <div v-if="clients" v-show="showClients">
              <li v-for="client in clients" :key="client.id" class="nav-item">
                <router-link
                  style="padding-left: 45px !important; padding-bottom: 5px !important"
                  tag="a"
                  :to="`/Client/${client.id}`"
                >
                  <div
                    class="avatar ml-0 pl-0"
                    style="text-align: left !important;"
                  ></div>
                  <span class="item-name">
                    • {{ client.name }}
                    <!-- </b-row> -->
                  </span>
                  <!-- </span> -->
                </router-link>
              </li>
            </div>
            <template v-else>
              <li v-for="n in 3" :key="n" class="nav-item skeleton">
                <b-row>
                  <b-col md="2">
                    <Skeleton class="mb-10" circle width="23px" height="23px" />
                  </b-col>
                  <b-col md="10">
                    <Skeleton class="mb-10 mt-10" />
                  </b-col>
                </b-row>
              </li>
            </template>
          </ul>
        </div>
        <!-- end of clients -->
        <div
          class="submenu-area"
          data-parent="leave"
          :class="{ 'd-block': selectedParentMenu == 'leave' }"
        >
          <header>
            <h6>Leave</h6>
            <p v-if="userIsSuperAdmin">Manage Leave</p>
            <p v-else>Apply for Leave</p>
          </header>
          <ul class="childNav" data-parent="leave">
            <li class="nav-item">
              <router-link tag="a" class to="/Leave/Apply">
                <i class="nav-icon i-Pen-2"></i>
                <span class="item-name">Apply</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" class to="/Leave/Summary">
                <i class="nav-icon i-Open-Book"> </i>
                <span class="item-name">Summary</span>
              </router-link>
            </li>
            <li v-if="userIsSuperAdmin" class="nav-item">
              <router-link tag="a" class to="/Leave/Grid">
                <i class="nav-icon i-Background"> </i>
                <span class="item-name">Grid</span>
              </router-link>
            </li>
            <li v-if="userIsSuperAdmin" class="nav-item">
              <router-link tag="a" class to="/Leave/Recipients">
                <i class="nav-icon i-Address-Book"> </i>
                <span class="item-name">Recipients</span>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- end of leave -->
        <div
          class="submenu-area"
          data-parent="leave"
          :class="{ 'd-block': selectedParentMenu == 'reports' }"
        >
          <header>
            <h6>Reports</h6>
            <p>Select report type</p>
          </header>
          <ul class="childNav" data-parent="leave">
            <li class="nav-item">
              <router-link tag="a" class to="/reports/quotes">
                <i class="nav-icon i-Quotes-2"> </i>
                <span class="item-name">Quotes</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" class to="/reports/resourceSheetReport">
                <i class="nav-icon i-Quotes-2"> </i>
                <span class="item-name">Resource Sheet</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" class to="/reports/flashReport">
                <i class="nav-icon i-Quotes-2"> </i>
                <span class="item-name">Flash Reports</span>
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link tag="a" class to="/reports/overdue">
                <i class="nav-icon i-Over-Time"> </i>
                <span class="item-name">Overdue Tasks</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" class to="/reports/unassigned">
                <i class="nav-icon i-Open-Book"> </i>
                <span class="item-name">Unassigned Tasks</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" class to="/reports/clientsReport">
                <i class="nav-icon i-Open-Book"> </i>
                <span class="item-name">Clients Report</span>
              </router-link>
            </li> -->
          </ul>
        </div>

        <!-- end of reports -->
        <div
          class="submenu-area"
          data-parent="settings"
          :class="{
            'd-block': 'settings' == selectedParentMenu
          }"
        >
          <header>
            <h6>Settings</h6>
            <p>Manage Scheduler</p>
          </header>
          <ul class="childNav" data-parent="settings">
            <li class="nav-item">
              <router-link tag="a" class to="/clients/manageClients">
                <i class="nav-icon i-Business-ManWoman"></i>
                <span class="item-name">Clients</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" class to="/Users/ManageUsers">
                <i class="nav-icon i-Search-People"></i>
                <span class="item-name">Users</span>
              </router-link>
            </li>
          </ul>
        </div>
        <!-- end of settings -->
        <div
          class="submenu-area"
          data-parent="timelogs"
          :class="{
            'd-block': 'timelogs' == selectedParentMenu
          }"
        >
          <header>
            <h6>Time Logs</h6>
            <p>View/Edit TimeLogs</p>
          </header>
          <ul class="childNav" data-parent="timelogs">
            <li v-if="userIsSuperAdmin" class="nav-item">
              <a @click="showTimelogModal">
                <i class="nav-icon i-Add"></i>
                <span class="item-name">Log Time</span>
              </a>
            </li>
            <li v-if="userIsSuperAdmin" class="nav-item">
              <router-link tag="a" class to="/TimeLogs/TimeLogs">
                <i class="nav-icon i-Clock-4"></i>
                <span class="item-name">Time Logs</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" class to="/TimeLogs/UserTimelogs">
                <i class="nav-icon i-Pen-6"></i>
                <span class="item-name">User Time Logs</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" class to="/TimeLogs/ClientSummary">
                <i class="nav-icon i-File-Clipboard"></i>
                <span class="item-name">Client Summary</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </vue-perfect-scrollbar>
    <div
      class="sidebar-overlay"
      :class="{
        open: isSideBarOpen && windowWidth <= 1200
      }"
      @click="removeOverlay()"
    ></div>

    <!--    Time Log Modal-->
    <TimeLogModal ref="timeLogModal" :is-ticket="false" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import Util from "@/utils"
import avatar from "@/components/projectAvatar"
import TimeLogModal from "@/components/timeLog/timeLogModal"
import { Skeleton } from "vue-loading-skeleton"
import Vue from "vue"
import VTooltip from "v-tooltip"
import QuickAddModal from "@/components/misc/quickAddModal"

Vue.use(VTooltip)

export default {
  components: {
    avatar,
    TimeLogModal,
    Skeleton,
    QuickAddModal
  },
  data() {
    return {
      isMenuOver: false,
      selectedParentMenu: "",
      //   isMobile,
      windowWidth: window.innerWidth,
      loadClients: false,
      showUsers: true,
      showClients: true,
      timeLog: {
        client: null,
        project: -1, // Default to Support
        task: null,
        description: null,
        date: this.$moment()._d,
        time: { HH: "00", mm: "00" },
        ticket: null,
        billable: null
      }
    }
  },
  apollo: {
    userClients: {
      query: require("@/graphql/Client/GetUserClients.gql"),
      variables() {
        return {
          userId: this.userId
        }
      },
      skip() {
        return !this.userId
      },
      fetchPolicy: "no-cache",
      update: data =>
        data.userClients?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
    },
    users: {
      query: require("@/graphql/Account/GetUsersLW.gql"),
      fetchPolicy: "no-cache",
      update: data =>
        data.users?.sort((a, b) => (a?.firstName > b?.firstName ? 1 : -1))
    },
    clients: {
      query: require("@/graphql/Client/GetClientsLW.gql"),
      fetchPolicy: "no-cache",
      update: data =>
        data.clients
          ?.filter(x => x.incompleteTickets || x.incompleteTasks)
          ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
    }
  },
  computed: {
    ...mapGetters({
      isSideBarOpen: "isOpen",
      currentUser: "getCurrentUser",
      getUnapprovedLeave: "leave/getUnapprovedLeave"
    }),
    testSite() {
      return process.env.NODE_ENV == "development"
    },

    userId() {
      return this.currentUser?.id
    },
    loading() {
      return this.currentUser == null
    },
    userIsSuperAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.includes("Super Admin")
      )
    },
    unapprovedLeave() {
      return this.getUnapprovedLeave.length > 0
    }
  },
  mounted() {
    this.toggleSelectedParentMenu()
    window.addEventListener("resize", this.handleWindowResize)
    document.addEventListener("click", this.returnSelectedParentMenu)
    this.handleWindowResize()
  },

  beforeDestroy() {
    document.removeEventListener("click", this.returnSelectedParentMenu)
    window.removeEventListener("resize", this.handleWindowResize)
  },
  methods: {
    ...mapMutations({ toggleOpen: "toggleOpen" }),
    compactSideBarToggle() {
      if (this.isSideBarOpen) {
        this.toggleOpen()
      }
    },
    handleWindowResize() {
      this.windowWidth = window.innerWidth
      if (window.innerWidth <= 1200) {
        if (this.isSideBarOpen) {
          this.toggleOpen()
        }
      } else {
        if (!this.isSideBarOpen) {
          this.toggleOpen()
        }
      }
    },
    toggleSelectedParentMenu() {
      const currentParentUrl = this.$route.path
        .split("/")
        .filter(x => x !== "")[0]
      const isAddUsers =
        this.$route.path
          .split("/")
          .filter(x => x !== "")
          .indexOf("addUser") !== -1
      const isManageUsers =
        this.$route.path
          .split("/")
          .filter(x => x !== "")
          .indexOf("ManageUsers") !== -1
      if (isAddUsers || isManageUsers) this.selectedParentMenu = "settings"
      else if (currentParentUrl === "overview") {
        this.selectedParentMenu = "dashboards"
      } else if (currentParentUrl !== undefined && currentParentUrl !== null) {
        this.selectedParentMenu = currentParentUrl.toLowerCase()
      } else {
        this.selectedParentMenu = "dashboards"
      }
    },
    /**
     *
     * @param e
     */
    toggleSubMenu(e) {
      this.selectedParentMenu = e.target.dataset.item
    },
    returnSelectedParentMenu() {
      if (!this.isMenuOver) {
        this.toggleSelectedParentMenu()
      }
    },
    toLink(projectName) {
      return Util.stringToLink(projectName)
    },
    /**
     * Gets client ticket and task count
     * @param client
     * @returns {*}
     */
    clientItemCount(client) {
      return this.clientTaskCount(client) + this.clientTicketCount(client)
    },
    /**
     * Gets client task count
     * @param client
     * @returns {number}
     */
    clientTaskCount(client) {
      return [].concat
        .apply(
          [],
          client.sections.map(x => x.tasks)
        )
        .filter(x => !x.completed).length
    },
    /**
     * Gets client ticket count
     * @param client
     * @returns {number}
     */
    clientTicketCount(client) {
      return client.tickets?.tasks?.filter(x => !x.completed).length
    },
    /**
     * Shows time log modal and pre-fills based on task
     */
    showTimelogModal() {
      this.$refs.timeLogModal.show()
    }
  }
}
</script>
<style scoped>
.version {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 8px;
  white-space: unset;
  margin-right: 8px;
  background-color: #af63e8;
}
.leave-alert {
  font-size: 1rem;
  position: absolute;
  left: 5px;
  top: 5px;
}

.leave-alert-summary {
  font-size: 1rem;
  position: absolute;
  left: 5px;
  top: 155px;
}

.skeleton {
  padding: 0.5rem 1.3rem;
}

.mt-10 > :first-child {
  margin-top: 10px;
}

.routerlink {
  padding: 0px !important;
}
</style>
